<template>
    <el-form :isCreate.sync="isCreate" :detail.sync="detail" :clearPriceData.sync="clearPriceData" label-position="left" label-width="200px" :model="form" :rules="rules" ref="calculateQuotationForm">
        <div class="text-md-left mb-22">
            <span class="text-bold">รายละเอียดแพ็กเกจ</span>
        </div>
        <el-form-item label="แพ็กเกจ (แบบรายเดือน)" label-width="200px" class="mr-10" prop="subscriptionPackageId">
            <el-select
                @change="calculateQuotation()"
                v-if="isCreate"
                placeholder="เลือกแพ็กเกจ"
                class="w-100"
                v-model="form.subscriptionPackageId"
            >
                <el-option v-for="(item, index) in subscriptionPackage" :key="index" :value="item.id" :label="item.name"></el-option>
            </el-select>
            <el-select
                v-else
                placeholder="เลือกแพ็กเกจ"
                class="w-100"
                v-model="detail.detail.subscriptionName"
                disabled
            >
            </el-select>
        </el-form-item>
        <el-form-item label="ระยะเวลาการใช้งาน (เดือน)" prop="cycles" label-width="200px" class="mr-10">
            <el-input
                v-if="isCreate"
                placeholder="กรอกระยะเวลาการใช้งาน"
                v-model="form.cycles"
                maxlength="2"
                @blur="checkCycles()"
                @keypress.native="cyclesValueChecker($event, form.cycles)"
            ></el-input>
            <el-input
                v-else
                placeholder="กรอกระยะเวลาการใช้งาน"
                v-model="detail.detail.cycles"
                disabled
            ></el-input>
        </el-form-item>
        <el-divider class="w-90"></el-divider>
        <div class="text-md-left mb-22">
            <span class="text-bold">รายละเอียดค่าบริการ</span>
        </div>
        <el-form-item label="ราคา" label-width="200px" class="mr-10">
            <el-input v-if="isCreate"
                placeholder="0.00"
                disabled
                :value="numberWithCommas(priceData.salePrice)"
            >
                <template slot="append">บาท</template>
            </el-input>
            <el-input v-else
                placeholder="0.00"
                disabled
                :value="numberWithCommas(detail.detail.salesPriceAmount)"
            >
                <template slot="append">บาท</template>
            </el-input>
        </el-form-item>
        <el-form-item label="ส่วนลด" label-width="200px" class="mr-10" prop="discountAmount">
            <el-input
                v-if="isCreate"
                placeholder="0.00"
                v-model="form.discountAmount"
                @blur="checkCallApi()"
                @keypress.native="integerValueChecker($event, form.discountAmount)"
            >
                <template slot="append">บาท</template>
            </el-input>
            <el-input
                v-else
                placeholder="0.00"
                :value="numberWithCommas(detail.detail.discountAmount)"
                disabled
            >
                <template slot="append">บาท</template>
            </el-input>
        </el-form-item>
        <el-form-item label="ราคาหลังหักส่วนลด" label-width="200px" class="mr-10">
            <el-input
                v-if="isCreate"
                placeholder="0.00"
                disabled
                :value="numberWithCommas(priceData.priceAfterDiscount)"
            >
                <template slot="append">บาท</template>
            </el-input>
            <el-input
                v-else
                placeholder="0.00"
                disabled
                :value="numberWithCommas(detail.detail.priceAfterDiscount)"
            >
                <template slot="append">บาท</template>
            </el-input>
        </el-form-item>
        <el-form-item label="ภาษีมูลค่าเพิ่ม 7%" label-width="200px" class="mr-10">
            <el-input
                v-if="isCreate"
                placeholder="0.00"
                disabled
                :value="numberWithCommas(priceData.vatAmount)"
            >
                <template slot="append">บาท</template>
            </el-input>
            <el-input
                v-else
                placeholder="0.00"
                disabled
                :value="numberWithCommas(detail.detail.vatAmount)"
            >
                <template slot="append">บาท</template>
            </el-input>
        </el-form-item>
        <el-form-item label="ยอดรวม" label-width="200px" class="mr-10">
            <el-input
                v-if="isCreate"
                placeholder="0.00"
                disabled
                :value="numberWithCommas(priceData.totalPrice)"
            >
                <template slot="append">บาท</template>
            </el-input>
            <el-input
                v-else
                placeholder="0.00"
                disabled
                :value="numberWithCommas(detail.detail.totalPrice)"
            >
                <template slot="append">บาท</template>
            </el-input>
        </el-form-item>
        <el-divider class="divider-dash w-90"></el-divider>
        <el-row type="flex" align="center" justify="space-between">
            <el-checkbox
                v-if="isCreate"
                class="form-checkbox-position"
                v-model="form.haveWht"
                @change="calculateQuotation()"
            ></el-checkbox>
            <el-checkbox
                v-if="!isCreate"
                class="form-checkbox-position"
                v-model="haveWht"
                disabled
            ></el-checkbox>
            <el-form-item label="หัก ณ ที่จ่าย 3%" label-width="170px" class="mr-10 w-100">
                <el-input
                    v-if="isCreate"
                    placeholder="0.00"
                    disabled
                    :value="numberWithCommas(priceData.whtAmount)"
                >
                    <template slot="append">บาท</template>
                </el-input>
                <el-input
                    v-else
                    placeholder="0.00"
                    disabled
                    :value="numberWithCommas(detail.detail.whtAmount)"
                >
                    <template slot="append">บาท</template>
                </el-input>
            </el-form-item>
        </el-row>
        <el-form-item label="ยอดรวมที่ต้องชำระ" label-width="200px" class="mr-10">
            <el-input
                v-if="isCreate"
                placeholder="0.00"
                disabled
                :value="numberWithCommas(priceData.netPrice)"
            >
                <template slot="append">บาท</template>
            </el-input>
             <el-input
                v-else
                placeholder="0.00"
                disabled
                :value="numberWithCommas(detail.detail.netPriceAmount)"
            >
                <template slot="append">บาท</template>
            </el-input>
        </el-form-item>
        <el-divider class="w-90"></el-divider>
    </el-form>
</template>

<script>
import fgApi from '@/services/fillgoods'
import numberWithCommas from '@/mixins/formatDigitMixin'

export default {
    name: 'formCreateQrPayment',
    mixins: [numberWithCommas],
    data () {
        let validatorDiscountAmount = (rule, value, callback) => {
            if (value) {
                if (value >= this.priceData.salePrice) {
                    callback(
                        new Error('ส่วนลดต้องน้อยกว่าราคาแพ็กเกจ')
                    )
                }
                callback()
            }
        }
        return {
            form: {
                subscriptionPackageId: '',
                discountAmount: '',
                cycles: '1',
                haveWht: false
            },
            rules: {
                subscriptionPackageId: [
                    { required: true, message: 'กรุณาเลือกแพ็กเกจ', trigger: 'blur' }
                ],
                cycles: [
                    { required: true, message: 'กรุณากรอกระยะเวลาการใช้งาน', trigger: 'blur' }
                ],
                discountAmount: [
                    {
                        required: false, message: 'ส่วนลดต้องน้อยกว่าราคาแพ็กเกจ', trigger: 'blur'
                    },
                    {
                        validator: validatorDiscountAmount,
                        trigger: ['blur', 'change']
                    }
                ]
            },
            priceData: [],
            subscriptionPackage: [],
            backupSubscriptionPackageId: '',
            backupCycles: ''
        }
    },
    props: {
        isCreate: {
            type: Boolean
        },
        detail: {
            type: Object,
            default: null
        },
        clearPriceData: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        callApi (val) {
            if (val) {
                this.calculateQuotation()
            }
        },
        clearPriceData: {
            handler (val) {
                if (val) {
                    this.priceData = []
                    this.form = {
                        subscriptionPackageId: '',
                        discountAmount: '',
                        cycles: '1',
                        haveWht: false
                    }
                }
            },
            immediate: true
        }
    },
    computed: {
        callApi () {
            if (this.form.subscriptionPackageId !== '' && this.form.cycles !== '') {
                return true
            } else {
                return false
            }
        },
        haveWht () {
            if (!this.detail.detail.whtAmount) {
                return false
            } else {
                return true
            }
        }
    },
    created () {
        this.getPackage()
    },
    methods: {
        async getPackage () {
            try {
                let res = await fgApi.subscription.getPackage()
                if (res.status === 'success') {
                    this.subscriptionPackage = res.data.filter(p => p.isActive === true)
                }
            } catch (error) {
                console.log(error)
            }
        },
        async calculateQuotation () {
            if (this.backupSubscriptionPackageId && (this.backupSubscriptionPackageId !== this.form.subscriptionPackageId)) {
                this.form.discountAmount = ''
            }
            if (this.backupCycles && (this.backupCycles !== this.form.cycles)) {
                this.form.discountAmount = ''
            }
            this.priceData = []
            let param = {
                subscriptionPackageId: this.form.subscriptionPackageId,
                discountAmount: parseFloat(this.form.discountAmount),
                cycles: parseInt(this.form.cycles),
                haveWht: this.form.haveWht
            }
            try {
                let res = await fgApi.subscription.calculateQuotation(param)
                if (res.status === 'success') {
                    this.priceData = res.data
                    this.backupSubscriptionPackageId = this.form.subscriptionPackageId
                    this.backupCycles = this.form.cycles
                    if (this.priceData.salePrice <= this.form.discountAmount) {
                        this.form.discountAmount = ''
                        this.priceData = []
                        this.calculateQuotation()
                    }
                    this.$emit('update:generateQrPaymentParam', { priceData: this.priceData, param: param })
                }
            } catch (error) {
                console.log(error)
            }
        },
        integerValueChecker (event, target) {
            let isAllow = /^\d*\.?\d*$/.test(event.which)
            if (isAllow) {
                target = target + event.key
                isAllow = /^\d*\.?\d*$/.test(target)
            }
            if (!isAllow) {
                event.preventDefault()
            }
            if (target === '0') {
                event.preventDefault()
            }
        },
        cyclesValueChecker (event, target) {
            let isAllow = /[0-9]/.test(String.fromCharCode(event.which))
            if (isAllow) {
                target = target + event.key
                if (target.length > 2) {
                    event.preventDefault()
                }
                isAllow = /^\d+$/.test(target)
            }
            if (!isAllow) {
                event.preventDefault()
            }
            if (target === '0') {
                event.preventDefault()
            }
        },
        checkCycles () {
            const invalidCycles = 0
            this.form.cycles = parseInt(this.form.cycles)
            if (this.form.cycles && this.form.cycles !== 0) {
                this.calculateQuotation()
            } else {
                this.form.cycles = ''
                this.$emit('update:generateQrPaymentParam', { cycles: invalidCycles })
            }
        },
        checkCallApi () {
            this.form.discountAmount = parseFloat(this.form.discountAmount).toFixed(2)
            if (isNaN(this.form.discountAmount)) {
                this.form.discountAmount = ''
            }
            const invalidDiscountAmount = -1
            if (this.form.discountAmount < this.priceData.salePrice) {
                this.calculateQuotation()
            } else if (this.form.discountAmount === undefined) {
                this.form.discountAmount = ''
                this.calculateQuotation()
            } else {
                this.$emit('update:generateQrPaymentParam', { discountAmount: invalidDiscountAmount })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// ::v-deep .el-form-item {
//     .el-form-item__label:after {
//         // display: ;
//     }
// }
::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
}
.form-checkbox-position {
    text-align: left;
    width: 5%;
    position: relative;
    top: 9px;
}
</style>
<style lang="scss">
.w-100 {
    width: 100%;
}
.w-90 {
    width: 90%;
}
.m-8 {
    margin: 8px;
}
.mr-10 {
    margin-right: 10%;
}
.mb-22 {
    margin-bottom: 22px;
}
.el-input.is-disabled .el-input__inner {
    color: #606266;
}
</style>
